import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ManeuverIcon } from './ManeuverIcon';
import { formatDistance } from '../lib/distance';
import { getManeuverInfo } from '../lib/maneuvers';

interface InstructionPanelProps {
  instruction: string;
  distanceToManeuver: number; // meters
  maneuverType: number;
  onBack: () => void;
  isOffRoute?: boolean;
}

export function InstructionPanel({
  instruction,
  distanceToManeuver,
  maneuverType,
  onBack,
  isOffRoute,
}: InstructionPanelProps) {
  const { label } = getManeuverInfo(maneuverType);

  return (
    <div className="absolute top-0 left-0 right-0 z-10 safe-area-inset-top">
      <div className="bg-background/95 backdrop-blur-sm shadow-lg m-3 rounded-xl border">
        {/* Off-route warning */}
        {isOffRoute && (
          <div className="bg-amber-500/20 text-amber-600 dark:text-amber-400 px-4 py-2 text-sm font-medium rounded-t-xl">
            Вы сошли с маршрута
          </div>
        )}

        {/* Main instruction with back button */}
        <div className="flex items-center gap-3 p-3">
          <Button
            size="icon"
            variant="ghost"
            className="h-10 w-10 shrink-0"
            onClick={onBack}
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>

          <ManeuverIcon type={maneuverType} size="lg" />

          <div className="flex-1 min-w-0">
            <p className="text-xl font-bold text-primary">
              {formatDistance(distanceToManeuver)}
            </p>
            <p className="text-sm font-medium truncate">
              {instruction || label}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
